const AUTH_EVENT = 'wb-auth-changed';

export function getStoredToken() {
  return localStorage.getItem('token');
}

export function isAuthenticated() {
  return Boolean(getStoredToken());
}

export function notifyAuthChanged() {
  window.dispatchEvent(new Event(AUTH_EVENT));
}

export function setAuthToken(token) {
  localStorage.setItem('token', token);
  notifyAuthChanged();
}

export function clearAuth() {
  localStorage.removeItem('token');
  localStorage.removeItem('clientId');
  notifyAuthChanged();
}

export function subscribeAuthChange(callback) {
  const onStorage = (event) => {
    if (!event.key || event.key === 'token') callback();
  };
  window.addEventListener(AUTH_EVENT, callback);
  window.addEventListener('storage', onStorage);
  return () => {
    window.removeEventListener(AUTH_EVENT, callback);
    window.removeEventListener('storage', onStorage);
  };
}
